/**
 * Utility functions for text manipulation
 */

/**
 * Strips HTML tags from a string and normalizes whitespace
 * @param html HTML string to clean
 * @returns Plain text with normalized whitespace
 */
export const useTextUtils = () => {
  const stripHtml = (html: string) => {
    return html ? html.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim() : ''
  }

  return {
    stripHtml,
  }
}
